<template>
  <q-page class="q-pa-md bg-grey-2">
    <!-- Header Card -->
    <q-card class="q-mb-md shadow-2 rounded-borders overflow-hidden">
      <div class="bg-primary text-white q-pa-md row items-center justify-between">
        <div class="row items-center">
          <q-icon name="people" size="md" class="q-mr-sm" />
          <div>
            <div class="text-h6 text-weight-bold">Gestión de Usuarios</div>
            <div class="text-caption text-blue-2">Listado general de usuarios registrados en la plataforma</div>
          </div>
        </div>
        <q-btn
          color="white"
          text-color="primary"
          icon="person_add"
          label="Agregar Usuario"
          unelevated
          rounded
          class="text-weight-bold"
          @click="AbrirNuevaUsuario"
        />
      </div>

      <!-- Filtros -->
      <q-card-section class="q-pa-md">
        <div class="row q-col-gutter-md items-center">
          <div class="col-12 col-sm-9 col-md-10">
            <q-input
              v-model="Buscar1"
              outlined
              dense
              placeholder="Buscar por DNI, Nombre o Email..."
              clearable
              @keyup.enter="BuscarProducto"
            >
              <template v-slot:prepend>
                <q-icon name="search" />
              </template>
            </q-input>
          </div>
          <div class="col-12 col-sm-3 col-md-2">
            <q-btn
              color="primary"
              icon="search"
              label="Buscar"
              class="full-width"
              unelevated
              @click="BuscarProducto"
            />
          </div>
        </div>
      </q-card-section>
    </q-card>

    <!-- Tabla Quasar -->
    <q-card class="shadow-2 rounded-borders">
      <q-table
        :data="ListaArticulos"
        :columns="columns"
        row-key="id_usuario"
        :pagination.sync="pagination"
        flat
        bordered
        no-data-label="No se encontraron usuarios registrados"
      >
        <template v-slot:body-cell-actions="props">
          <q-td :props="props" class="text-right">
            <q-btn
              flat
              round
              color="primary"
              icon="edit"
              size="sm"
              @click="Editar(props.row.id_usuario)"
            >
              <q-tooltip>Editar Usuario</q-tooltip>
            </q-btn>
            <q-btn
              flat
              round
              color="warning"
              icon="visibility"
              size="sm"
              @click="Detalle(props.row.id_usuario)"
            >
              <q-tooltip>Ver Detalle</q-tooltip>
            </q-btn>
          </q-td>
        </template>
      </q-table>
    </q-card>
  </q-page>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      pagination: { rowsPerPage: 50 },
      NumerosPaginas: 1,
      TotalPaginas: 0,
      TamanoPagina: 50,
      Buscar1: "",
      ListaArticulos: [],
      columns: [
        { name: "id_usuario", label: "Id", field: "id_usuario", align: "left", sortable: true },
        { name: "dni", label: "DNI", field: "dni", align: "left", sortable: true },
        { name: "email", label: "Email", field: "email", align: "left" },
        { name: "telefono", label: "Teléfono", field: "telefono", align: "left" },
        { name: "estado", label: "Estado", field: "estado", align: "center" },
        { name: "actions", label: "Acciones", field: "actions", align: "right" },
      ],
    };
  },
  created() {
    this.Listar();
  },
  methods: {
    Editar(id) {
      this.$router.push("/aveo/Usuario/Nuevo/" + id);
    },
    Detalle(id) {
      this.$router.push("/aveo/Usuario/UsuarioDetalle/" + id);
    },
    AbrirNuevaUsuario() {
      this.$router.push("/registro");
    },
    BuscarProducto() {
      let me = this;
      axios({
        method: "post",
        url: "ApiWeb/UsuarioLista.php",
        data: {
          ruc: this.Buscar1,
          razonsocial: this.Buscar1,
        },
      })
        .then(function(response) {
          me.ListaArticulos = response.data.data || [];
          me.TotalPaginas = response.data.totalRegistros || 0;
          me.TamanoPagina = response.data.tamanoPagina || 50;
        })
        .catch(function(error) {
          console.error(error);
        });
    },
    Listar() {
      let me = this;
      axios
        .post("ApiWeb/UsuarioLista.php", {
          Buscar1: "",
          Pagina: 1,
          TPagina: 50,
        })
        .then(function(response) {
          me.ListaArticulos = response.data.data || [];
          me.TotalPaginas = response.data.totalRegistros || 0;
          me.TamanoPagina = response.data.tamanoPagina || 50;
        })
        .catch(function(error) {
          console.error(error);
        });
    },
  },
};
</script>
